import { render, staticRenderFns } from "./FccImagens.vue?vue&type=template&id=1fadafa3"
import script from "./FccImagens.vue?vue&type=script&lang=js"
export * from "./FccImagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports